<template>
    <div class="text-sm" v-if="hasBilling && subscription.trial_days_left !== null">
        <div class="py-2 flex items-center justify-center bg-primary-lighter text-primary-darkest rounded" v-if="subscription.trial_days_left > 0">
            <p><strong>🚀 {{ subscription.trial_days_left }}</strong> days left in your free trial. <a href="/billing" class="underline"><strong>Upgrade now</strong></a></p>
        </div>
        <div class="py-2 flex items-center justify-center bg-destructive text-white rounded" v-else-if="subscription.trial_days_left <= 0">
            <p>😐 Your free trial period has ended. <a href="/billing" class="underline"><strong>Upgrade now</strong></a></p>
        </div>
    </div>
</template>

<script setup>
    export default {
        data() {
            return {
                hasBilling  : window.User.has_billing,
                subscription: {},
            }
        },
        mounted() {
            axios.get('/api/subscription')
                .then(response => {
                    this.subscription = response.data.data;
                })
                .catch(err => console.error);
        }
    }
</script>
